import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { EbookSection } from './components/EbookSection';
import { BenefitsSection } from './components/BenefitsSection';
import { InsideSection } from './components/InsideSection';
import { ForYouSection } from './components/ForYouSection';
import { TransformationSection } from './components/TransformationSection';
import { ManifestoSection } from './components/ManifestoSection';
import { PricingSection } from './components/PricingSection';
import { UrgencySection } from './components/UrgencySection';
import { FaqSection } from './components/FaqSection';
import { FinalSection } from './components/FinalSection';
import { SiteFooter } from './components/SiteFooter';
import { StickyBar } from './components/StickyBar';
export function App() {
  return <div className="min-h-screen w-full bg-void-950 font-sans" data-id="element-0" data-mp="28sbcb6dz997p">
      <Hero data-id="element-1" data-mp="23u9q4cl98ts0" />
      <main data-id="element-2" data-mp="23utby4e102bb">
        <ProblemSection data-id="element-3" data-mp="23v2uj6wqr76z" />
        <EbookSection data-id="element-4" data-mp="3ijxo6nd1puib" />
        <BenefitsSection data-id="element-5" data-mp="3ikr002qv3a7b" />
        <InsideSection data-id="element-6" data-mp="3ij61y35c994p" />
        <ForYouSection data-id="element-7" data-mp="3ihv048vgebg8" />
        <TransformationSection data-id="element-8" data-mp="3mlawd43m29se" />
        <ManifestoSection data-id="element-9" data-mp="3mkhn9wh6j873" />
        <PricingSection data-id="element-10" data-mp="3mjq2lgp4euvl" />
        <UrgencySection data-id="element-11" data-mp="3rc9em985thya" />
        <FaqSection data-id="element-12" data-mp="3rbrc4uuwm7hx" />
        <FinalSection data-id="element-13" data-mp="3rdki07xp0nov" />
      </main>
      <SiteFooter data-id="element-14" data-mp="3recctgjguhe3" />
      <StickyBar data-id="element-15" data-mp="5yh2n2cyzbp" />
    </div>;
}